import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69041b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highlight" }
const _hoisted_2 = ["src"]

interface Props {
  /** source of video */
  src: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHighlight',
  props: {
    src: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", {
      src: __props.src,
      muted: "",
      autoplay: "",
      loop: "",
      controls: ""
    }, null, 8, _hoisted_2),
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})